import dayjs from "dayjs";

// Rekent uit hoe ver het team is en wat er nog nodig is.
//
//  - hasTarget: is er überhaupt een target bekend? Zonder target valt er
//               niets te halen, dus dan blijft alles op nul staan. Anders
//               zou een mislukte teamTarget-call "100%" opleveren, en dat
//               leest op de tv als "target gehaald".
//  - percent:   hoeveel procent van het target binnen is (kan boven 100)
//  - remaining: wat er nog te gaan is in euro's
//  - daysLeft:  hoeveel dagen deze maand nog over zijn
//  - perDay:    wat er per resterende dag binnen moet komen
export function targetProgress({ scored, target, month, year }) {
  const goal = Number(target) > 0 ? Number(target) : 0;
  const hasTarget = goal > 0;
  const done = Number(scored) || 0;

  const percent = hasTarget
    ? Math.max(0, Math.floor((done / goal) * 100))
    : 0;

  const daysInMonth = dayjs(`${year}-${month}`).daysInMonth();
  const daysLeft = Math.max(0, daysInMonth - new Date().getDate());

  const remaining = hasTarget ? Math.max(0, goal - done) : 0;
  const perDay = daysLeft > 0 ? Math.ceil(remaining / daysLeft) : remaining;

  return { hasTarget, percent, remaining, daysLeft, perDay };
}
